import { Loader2 } from 'lucide-react'

export function Cargando({ texto = 'Cargando…' }: { texto?: string }) {
  return (
    <p className="cargando" role="status">
      <Loader2 className="dcc-i girando" size={20} aria-hidden />
      {texto}
    </p>
  )
}
